module.exports = __webpack_public_path__ + "img/chart.fe04fc77.svg";